import React, { Component } from 'react';

import Link from 'next/link';
import { Icon } from 'semantic-ui-react';
import { withRouter } from 'next/router';
import flatten from 'lodash/flatten';

import Tag from './Tag';

/**
 * Application main header
 * @title header title. Can be a string or React element
 * @backButton object { href: string, as: string, text: string } (optional)
 * @actionButton object { text: string, href: string, as: string, icon: string, component: React element, ...otherButtonParams } (optional)
 * @description string or React element (optional)
 * @tags list of strings with tag names (optional)
 */

/**
 * @typedef {{
 *  title: string,
 *  backButton: {
 *    href: string,
 *    as: string,
 *    text: string
 *  },
 *  showDisabledButton?: {
 *    href: string,
 *    text: string,
 *    as: string,
 *    icon?: string,
 *    component?: JSX.Element
 *  },
 *  actionButton: {
 *    text: string,
 *    href?: string,
 *    as: string,
 *    icon: string,
 *    component?: JSX.Element
 *  },
 *  tags: string[] | { name: string, type: string }[],
 *  statusTags: string[] | { name: string, type: string }[],
 *  footer: JSX.Element,
 *  description?: string | JSX.Element,
 *  traceBack: {
 *    link: string,
 *    as: string,
 *    text: string
 *  }[]
 * }} Header
 * @extends {Component<Header>}
 */
class MainHeader extends React.Component {
  /**
   * @param {string} type
   * @param {string | number | object} value
   * TODO remove useless function
   */
  onValueChange = (type, value) => {
    this.setState(
      { [type]: value },
      // @ts-ignore
      () => this.request()
    );
  }

  /** @param {string[] | { name: string, type: string }[]} tags */
  renderTags = tags => (
    <div className="tag-list header">
      {tags.map(tag => (typeof tag === 'string'
        ? <Tag name={tag} key={tag} />
        : <Tag key={tag.name} className={tag.type} {...tag} />))}
    </div>
  )

  renderBreadcrumb = () => {
    const { traceBack } = this.props;

    if (!traceBack || traceBack.length < 2) return null;

    const children = flatten(traceBack.map((page, index) => (
      index < traceBack.length - 1 ? [
        page.link ? <Link href={page.link} as={page.as} key={page.link}>{page.text}</Link> : <span key="last-breadcrumb-link">{page.text}</span>,
        <Icon className="angle right" key={`icon-angle-${index}`} />
      ] : [
        <span key="last-breadcrumb-item">{page.text}</span>
      ]
    )));
    return <div className="breadcrumb">{children}</div>;
  }

  render() {
    const {
      title, backButton, showDisabledButton, actionButton, tags, statusTags, footer, description
    } = this.props;

    return (
      <div className="main-header">
        <div className="main-content">
          {backButton
            // @ts-ignore
            ? <Link href={backButton.href} as={backButton.as} className="back-button">{backButton.text}</Link>
            : this.renderBreadcrumb()}

          <div className="content">
            <div className="left">
              <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                {typeof title === 'string' ? <h1>{title}</h1> : <div className="title-wrapper">{title}</div>}
                {statusTags && this.renderTags(statusTags)}
              </div>
              {description && <div className="description">{description}</div>}
            </div>

            <div className="right">
              {showDisabledButton && (showDisabledButton.href
                ? (
                  <Link href={showDisabledButton.href} as={showDisabledButton.as}>
                    <button type="button" {...showDisabledButton}>
                      {showDisabledButton.icon && <Icon className={showDisabledButton.icon} />}
                      {showDisabledButton.text}
                    </button>
                  </Link>
                ) : showDisabledButton.component ? showDisabledButton.component : (
                  <button type="button" {...showDisabledButton}>
                    {showDisabledButton.icon && <Icon className={showDisabledButton.icon} />}
                    {showDisabledButton.text}
                  </button>
                ))}
              {actionButton && (actionButton.href
                ? (
                  <Link href={actionButton.href} as={actionButton.as}>
                    <button type="button" {...actionButton}>
                      {actionButton.icon && <Icon className={actionButton.icon} />}
                      {actionButton.text}
                    </button>
                  </Link>
                ) : actionButton.component ? actionButton.component : (
                  <button type="button" {...actionButton}>
                    {actionButton.icon && <Icon className={actionButton.icon} />}
                    {actionButton.text}
                  </button>
                ))}
            </div>
          </div>

          {tags && this.renderTags(tags)}
        </div>

        {footer}
      </div>
    );
  }
}
// @ts-ignore
export default withRouter(MainHeader);
